import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function listVehicles(params = {}) {
  const { data } = await axios.get(`${API}/vehicles`, { params, withCredentials: true });
  return data.vehicles;
}

export async function getVehicle(id) {
  const { data } = await axios.get(`${API}/vehicles/${id}`, { withCredentials: true });
  return data;
}

export async function createVehicle(payload) {
  const { data } = await axios.post(`${API}/vehicles`, payload);
  return data;
}

export async function listInquiries(vehicleId) {
  const { data } = await axios.get(`${API}/inquiries`, { params: { vehicle_id: vehicleId }, withCredentials: true });
  return data.inquiries;
}

export async function createInquiry(payload) {
  const { data } = await axios.post(`${API}/inquiries`, payload);
  return data;
}
